import api from "../api/axiosInstance";

const hsCodeService = {
    getAll: (params) => api.get("/hs-codes", { params }),
    search: (q) => api.get("/hs-codes/search", { params: { q } }),
    update: (id, data) => api.patch(`/hs-codes/${id}`, data),
    delete: (id) => api.delete(`/hs-codes/${id}`),
    bulkUpload: (file) => {
        const formData = new FormData();
        formData.append("file", file);
        return api.post("/hs-codes/bulk-upload", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
};

export default hsCodeService;